var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lengthGood)?_c('span',[_vm._v(_vm._s(this.value.trim()))]):_c('span',{on:{"click":_vm.handleClick}},[_c('abbr',{attrs:{"title":this.value.trim()}},[_vm._v(_vm._s(this.truncatedAtLength))])])}
var staticRenderFns = []

export { render, staticRenderFns }